// Suporte.js
import React, { useEffect, useState } from 'react';
import api from '../api';
import './estilodash.css';

const Suporte = () => {
  const [arquivos, setArquivos] = useState([]);

  useEffect(() => {
    fetchArquivos();
  }, []);

  const fetchArquivos = async () => {
    try {
      const response = await api.get('/api/arquivos');
      setArquivos(response.data || []);
    } catch (error) {
      console.error('Erro ao listar arquivos para download:', error);
    }
  };

  return (
    <div className="container-suporte">
      <h2>Contato e Suporte</h2>

      <div className="suporte-grid">
        {/* Coluna da esquerda */}
        <div className="suporte-col">
          <div className="suporte-secao">
            <h3>Informações de Contato</h3>
            <p>
              📱{' '}
              <a
                href="https://wa.me/5542984241307"
                target="_blank"
                rel="noreferrer"
              >
                WhatsApp: (42) 98424-1307
              </a>
            </p>
            <p>
              📧{' '}
              <a href="mailto:contato@quantumtrades.com.br">
                contato@quantumtrades.com.br
              </a>
            </p>
            <p>
              📧{' '}
              <a href="mailto:suporte@quantumtrades.com.br">
                suporte@quantumtrades.com.br
              </a>{' '}
              (Suporte)
            </p>
            <p>
              📺{' '}
              <a
                href="https://www.youtube.com/@QuantumTradesBR"
                target="_blank"
                rel="noreferrer"
              >
                YouTube
              </a>
            </p>
            <p>
              📨{' '}
              <a
                href="https://t.me/QuantumTradesBr"
                target="_blank"
                rel="noreferrer"
              >
                Canal Telegram Aberto
              </a>
            </p>
            <p>
              👥{' '}
              <a
                href="https://t.me/+tdXvf6jsLSZmZjlh"
                target="_blank"
                rel="noreferrer"
              >
                Grupo Telegram VIP para Assinantes
              </a>
            </p>
          </div>

          <div className="suporte-secao">
            <h3>Arquivos para Download</h3>
            {arquivos.length === 0 ? (
              <p>Nenhum arquivo disponível.</p>
            ) : (
              <ul>
                {arquivos.map((nome, index) => (
                  <li key={index}>
                    <a
                      href={`https://quantumtrades.com.br:8080/downloads/${nome}`}
                      download
                    >
                      {nome}
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        {/* Coluna da direita */}
        <div className="suporte-col">
          <div className="suporte-secao">
            <h3>Recomendação de Corretora Forex</h3>
            <p>
              💹 Recomendamos a <strong>Exness</strong> para operações em Forex:
              <br />
              <a
                href="https://one.exnesstrack.org/a/hkga5cflzh"
                target="_blank"
                rel="noreferrer"
                style={{ fontWeight: 'bold' }}
              >
                Clique aqui para abrir sua conta Exness
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Suporte;
